var _path, _path2, _rect, _g, _path3, _rect2, _rect3, _rect4, _rect5, _g2, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidationRule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 94,
    viewBox: "0 0 122 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.416 38.2727V21.9091",
    stroke: "#8D6BF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 65V48C30.0625 43.5817 33.6442 40 38.0625 40H83.0625C87.4808 40 91.0625 43.5817 91.0625 48V65",
    stroke: "#8D6BF7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.9148,
    y: 40.2727,
    width: 8,
    height: 8,
    rx: 2,
    transform: "rotate(-45 54.9148 40.2727)",
    fill: "#8D6BF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1044_10982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.9375,
    y: 48,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.185 58.225C93.1504 58.0556 93.0584 57.9033 92.9244 57.794C92.7905 57.6847 92.6229 57.625 92.45 57.625H87.065C86.8661 57.625 86.6753 57.704 86.5347 57.8447C86.394 57.9853 86.315 58.1761 86.315 58.375V69.625C86.315 69.8239 86.394 70.0147 86.5347 70.1553C86.6753 70.296 86.8661 70.375 87.065 70.375C87.2639 70.375 87.4547 70.296 87.5953 70.1553C87.736 70.0147 87.815 69.8239 87.815 69.625V65.125H92.015L92.195 66.025C92.2625 66.376 92.5723 66.6288 92.93 66.625H96.815C97.0139 66.625 97.2047 66.546 97.3453 66.4053C97.486 66.2647 97.565 66.0739 97.565 65.875V59.875C97.565 59.6761 97.486 59.4853 97.3453 59.3447C97.2047 59.204 97.0139 59.125 96.815 59.125H93.365L93.185 58.225Z",
    fill: "#E37777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0625,
    width: 96,
    height: 28,
    rx: 6,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5625,
    y: 0.5,
    width: 95,
    height: 27,
    rx: 5.5,
    stroke: "#94A1AF",
    strokeOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2897,
    y: 8,
    width: 48.0001,
    height: 3,
    rx: 1.5,
    fill: "#94A1AF",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2881,
    y: 16.6366,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "#94A1AF",
    fillOpacity: 0.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1044_10982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.0625,
    y: 48,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0601 56.5C21.9201 56.5 18.5601 59.86 18.5601 64C18.5601 68.14 21.9201 71.5 26.0601 71.5C30.2001 71.5 33.5601 68.14 33.5601 64C33.5601 59.86 30.2001 56.5 26.0601 56.5ZM24.0276 67.2175L21.3351 64.525C21.2656 64.4556 21.2105 64.3731 21.173 64.2824C21.1354 64.1917 21.116 64.0944 21.116 63.9963C21.116 63.8981 21.1354 63.8008 21.173 63.7101C21.2105 63.6194 21.2656 63.5369 21.3351 63.4675C21.4045 63.3981 21.4869 63.343 21.5777 63.3054C21.6684 63.2678 21.7656 63.2485 21.8638 63.2485C21.962 63.2485 22.0592 63.2678 22.15 63.3054C22.2407 63.343 22.3231 63.3981 22.3926 63.4675L24.5601 65.6275L29.7201 60.4675C29.8603 60.3273 30.0505 60.2485 30.2488 60.2485C30.4471 60.2485 30.6373 60.3273 30.7776 60.4675C30.9178 60.6077 30.9966 60.7979 30.9966 60.9963C30.9966 61.1946 30.9178 61.3848 30.7776 61.525L25.0851 67.2175C25.0157 67.287 24.9333 67.3422 24.8425 67.3798C24.7518 67.4175 24.6545 67.4368 24.5563 67.4368C24.4581 67.4368 24.3608 67.4175 24.2701 67.3798C24.1794 67.3422 24.0969 67.287 24.0276 67.2175Z",
    fill: "#6BBD60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1044_10982",
    x: 65.9375,
    y: 38,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.219608 0 0 0 0 0.501961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1044_10982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1044_10982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1044_10982",
    x: 0.0625,
    y: 38,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.219608 0 0 0 0 0.501961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1044_10982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1044_10982",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationRule);
export default __webpack_public_path__ + "static/media/validation-rule.063aba51542db9f354861591287af8c1.svg";
export { ForwardRef as ReactComponent };